import { render, staticRenderFns } from "./RoleBadge.vue?vue&type=template&id=64adc628&scoped=true"
import script from "./RoleBadge.vue?vue&type=script&lang=js"
export * from "./RoleBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64adc628",
  null
  
)

export default component.exports